import Column from '@amzn/meridian/column';
import Input from '@amzn/meridian/input';
import Row from '@amzn/meridian/row';
import Select from '@amzn/meridian/select';
import Text from '@amzn/meridian/text';

import React from 'react';

/** Displayed when not editing and there are no webhooks for the given event type. Its implemented as a separate
 *   component because I don't want to relax type checking on the component performing actual edits  */
const BlankWebhookRow = ({ austinOnly }: { austinOnly: boolean }) => {
  const columnWidths = austinOnly ? ['fill', 'grid-2'] : ['fill', 'grid-3', 'grid-2'];
  return (
    <Row widths={columnWidths} spacingInset="300 none">
      <Column spacing="100">
        <Text>URL 1 (Chime or Slack)</Text>
        <Input
          id={`site-webhook__url-input__blank-row`}
          data-cy={`site-webhook__url-input__blank-row`}
          type="text"
          placeholder="Url..."
          disabled={true}
        />
      </Column>
      {!austinOnly && (
        <Column spacing="100">
          <Text>Receive alerts for:</Text>
          <Select
            id={`site-webhook__accommodation-type-select__blank-row`}
            data-cy={`site-webhook__accommodation-type-select__blank-row`}
            placeholder="Select..."
            disabled={true}
          >
            <></>
          </Select>
        </Column>
      )}
      {/* Empty column for spacing */}
      <Column />
    </Row>
  );
};

export default BlankWebhookRow;
